import QCheckboxGroup from '../checkbox/src/checkbox-group.vue';

export default QCheckboxGroup;
